import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '@/views/layouts/Main'
import Login from '@/views/layouts/Login'
import Plain from '@/views/layouts/Plain'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    name: '404',
    meta: {
      title: '404 - Stránka nenalezena',
      layout: Plain,
    },
    component: () => import(/* webpackChunkName: "404" */ '@/views/errors/404.vue'),
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: 'Přihlášení',
      layout: Login,
    },
    component: () => import(/* webpackChunkName: "login" */ '@/views/pages/login/Login.vue'),
  },
  {
    path: '/',
    name: 'home',
    meta: {
      title: 'Administrace',
      layout: Plain,
    },
    component: () => import(/* webpackChunkName: "home" */ '@/views/pages/home/Home.vue'),
  },
  {
    path: '/password-lost',
    name: 'password-lost',
    meta: {
      title: 'Zapomenuté heslo',
      layout: Login,
    },
    component: () =>
      import(/* webpackChunkName: "passwordLost" */ '@/views/pages/password/PasswordLost.vue'),
  },
  {
    path: '/password-reset',
    name: 'password-reset',
    meta: {
      title: 'Obnova hesla',
      layout: Login,
    },
    component: () =>
      import(/* webpackChunkName: "passwordReset" */ '@/views/pages/password/PasswordReset.vue'),
  },
  {
    path: '/password-setup',
    name: 'password-setup',
    meta: {
      title: 'Nastavení hesla',
      layout: Login,
    },
    component: () =>
      import(/* webpackChunkName: "passwordSetup" */ '@/views/pages/password/PasswordSetup.vue'),
  },
  {
    path: '/electricity-calculator',
    name: 'electricity-calculator',
    meta: {
      title: 'Kalkulačka elektřina',
      layout: Main,
    },
    component: () =>
      import(
        /* webpackChunkName: "electricityCalculator" */ '@/views/pages/calculator/ElectricityCalculator.vue'
      ),
  },
  {
    path: '/gas-calculator',
    name: 'gas-calculator',
    meta: {
      title: 'Kalkulačka plyn',
      layout: Main,
    },
    component: () =>
      import(/* webpackChunkName: "gasCalculator" */ '@/views/pages/calculator/GasCalculator.vue'),
  },
  {
    path: '/setting',
    name: 'setting',
    meta: {
      title: 'Nastavení',
      layout: Main,
    },
    component: () =>
      import(/* webpackChunkName: "settingDocusign" */ '@/views/pages/setting/SettingDetail.vue'),
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    meta: {
      title: 'Dashboard',
      layout: Main,
      requiresAuth: true,
      roles: ['ROLE_ADMIN'],
    },
    component: () =>
      import(/* webpackChunkName: "dashboard" */ '@/views/pages/dashboard/Dashboard.vue'),
  },
  {
    path: '/notifications',
    name: 'notifications',
    meta: {
      title: 'Upozornění',
      layout: Main,
      requiresAuth: true,
      roles: ['ROLE_ADMIN'],
    },
    component: () =>
      import(
        /* webpackChunkName: "notifications" */ '@/views/pages/notification/Notifications.vue'
      ),
  },
  {
    path: '/administrators',
    meta: {
      title: 'administrators',
      requiresAuth: true,
      roles: ['ROLE_ADMIN'],
    },
    component: () =>
      import(/* webpackChunkName: "emptyRouterView" */ '@/views/pages/common/EmptyRouterView.vue'),
    children: [
      {
        path: '/administrators',
        name: 'administrators',
        meta: {
          title: 'Přehled administrátorů',
          layout: Main,
          requiresAuth: true,
          roles: ['ROLE_ADMIN'],
        },
        component: () =>
          import(
            /* webpackChunkName: "administrators" */ '@/views/pages/administrator/Administrators.vue'
          ),
      },
      {
        path: ':id/detail',
        name: 'administrators.detail',
        meta: {
          parent: 'administrators',
          title: 'Detail administrátora',
          layout: Main,
          requiresAuth: true,
          roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
        },
        component: () =>
          import(
            /* webpackChunkName: "administratorDetail" */ '@/views/pages/administrator/AdministratorDetail.vue'
          ),
      },
      {
        path: ':id/edit',
        name: 'administrators.edit',
        meta: {
          parent: 'administrators.detail',
          title: 'Editace administrátora',
          layout: Main,
          requiresAuth: true,
          roles: ['ROLE_ADMIN'],
        },
        component: () =>
          import(
            /* webpackChunkName: "administratorEdit" */ '@/views/pages/administrator/AdministratorEdit.vue'
          ),
      },
      {
        path: 'add',
        name: 'administrators.add',
        meta: {
          parent: 'administrators',
          title: 'Nový administrátor',
          layout: Main,
          requiresAuth: true,
          roles: ['ROLE_ADMIN'],
        },
        component: () =>
          import(
            /* webpackChunkName: "administratorAdd" */ '@/views/pages/administrator/AdministratorAdd.vue'
          ),
      },
    ],
  },
  {
    path: '/users',
    meta: {
      title: 'users',
      requiresAuth: true,
      roles: ['ROLE_ADMIN'],
    },
    component: () =>
      import(/* webpackChunkName: "emptyRouterView" */ '@/views/pages/common/EmptyRouterView.vue'),
    children: [
      {
        path: '/users',
        name: 'users',
        meta: {
          title: 'Přehled uživatelů',
          layout: Main,
          requiresAuth: true,
          roles: ['ROLE_ADMIN'],
        },
        component: () => import(/* webpackChunkName: "users" */ '@/views/pages/user/Users.vue'),
      },
    ],
  },
  {
    path: '/customers',
    meta: {
      title: 'customers',
      requiresAuth: true,
      roles: ['ROLE_ADMIN'],
    },
    component: () =>
      import(/* webpackChunkName: "emptyRouterView" */ '@/views/pages/common/EmptyRouterView.vue'),
    children: [
      {
        path: '/customers',
        name: 'customers',
        meta: {
          title: 'Přehled zákazníků',
          layout: Main,
          requiresAuth: true,
          roles: ['ROLE_ADMIN'],
        },
        component: () =>
          import(/* webpackChunkName: "customers" */ '@/views/pages/customer/Customers.vue'),
      },
      {
        path: ':customerId/detail',
        name: 'customers.detail',
        meta: {
          parent: 'customers',
          title: 'Detail zákazníka',
          layout: Main,
          requiresAuth: true,
          roles: ['ROLE_ADMIN'],
        },
        component: () =>
          import(
            /* webpackChunkName: "customerDetail" */ '@/views/pages/customer/CustomerDetail.vue'
          ),
      },
      {
        path: 'add',
        name: 'customers.add',
        meta: {
          parent: 'customers',
          title: 'Nový zákazník',
          layout: Main,
          requiresAuth: true,
          roles: ['ROLE_ADMIN'],
        },
        component: () =>
          import(/* webpackChunkName: "customerAdd" */ '@/views/pages/customer/CustomerAdd.vue'),
      },
      {
        path: ':customerId/edit',
        name: 'customers.edit',
        meta: {
          parent: 'customers.detail',
          title: 'Editace zákazníka',
          layout: Main,
          requiresAuth: true,
          roles: ['ROLE_ADMIN'],
        },
        component: () =>
          import(/* webpackChunkName: "customerEdit" */ '@/views/pages/customer/CustomerEdit.vue'),
      },
      {
        path: ':customerId/merge',
        name: 'customers.merge',
        meta: {
          parent: 'customers.detail',
          title: 'Sloučení zákazníků',
          layout: Main,
          requiresAuth: true,
          roles: ['ROLE_ADMIN'],
        },
        component: () =>
          import(/* webpackChunkName: "customerEdit" */ '@/views/pages/customer/CustomerMerge.vue'),
      },
      {
        path: ':customerId/address/:id/edit',
        name: 'customers.address.edit',
        meta: {
          parent: 'customers.detail',
          title: 'Editace adresy',
          layout: Main,
          requiresAuth: true,
          roles: ['ROLE_ADMIN'],
        },
        component: () =>
          import(/* webpackChunkName: "addressEdit" */ '@/views/pages/address/AddressEdit.vue'),
      },
      {
        path: ':customerId/order/add',
        name: 'customers.orders.add',
        meta: {
          parent: 'customers.detail',
          title: 'Nová objednávka',
          layout: Main,
          requiresAuth: true,
          roles: ['ROLE_ADMIN'],
        },
        component: () =>
          import(/* webpackChunkName: "administratorAdd" */ '@/views/pages/order/OrderAdd.vue'),
      },
    ],
  },
  {
    path: '/orders',
    meta: {
      title: 'orders',
      requiresAuth: true,
      roles: ['ROLE_ADMIN'],
    },
    component: () =>
      import(/* webpackChunkName: "emptyRouterView" */ '@/views/pages/common/EmptyRouterView.vue'),
    children: [
      {
        path: '/orders',
        name: 'orders',
        meta: {
          title: 'Přehled objednávek',
          layout: Main,
          requiresAuth: true,
          roles: ['ROLE_ADMIN'],
        },
        component: () =>
          import(/* webpackChunkName: "customers" */ '@/views/pages/order/Orders.vue'),
      },
      {
        path: ':orderId/detail',
        name: 'orders.detail',
        meta: {
          parent: 'orders',
          title: 'Detail objednávky',
          layout: Main,
          requiresAuth: true,
          roles: ['ROLE_ADMIN'],
        },
        component: () =>
          import(/* webpackChunkName: "orderDetail" */ '@/views/pages/order/OrderDetail.vue'),
      },
      {
        path: ':orderId/edit',
        name: 'orders.edit',
        meta: {
          parent: 'orders.detail',
          title: 'Editace objednávky',
          layout: Main,
          requiresAuth: true,
          roles: ['ROLE_ADMIN'],
        },
        component: () =>
          import(/* webpackChunkName: "orderEdit" */ '@/views/pages/order/OrderEdit.vue'),
      },
      {
        path: 'add',
        name: 'orders.add',
        meta: {
          parent: 'orders',
          title: 'Nová objednávka',
          layout: Main,
          requiresAuth: true,
          roles: ['ROLE_ADMIN'],
        },
        component: () =>
          import(/* webpackChunkName: "administratorAdd" */ '@/views/pages/order/OrderAdd.vue'),
      },
      {
        path: ':assignId/customer/:customerId/assign',
        name: 'orders.assign',
        meta: {
          parent: 'orders.detail',
          title: 'Převod na objednávku',
          layout: Main,
          requiresAuth: true,
          roles: ['ROLE_ADMIN'],
        },
        component: () =>
          import(/* webpackChunkName: "administratorAdd" */ '@/views/pages/order/OrderAdd.vue'),
      },
      {
        path: ':orderId/address/:id/edit',
        name: 'orders.address.edit',
        meta: {
          parent: 'orders.detail',
          title: 'Editace adresy',
          layout: Main,
          requiresAuth: true,
          roles: ['ROLE_ADMIN'],
        },
        component: () =>
          import(/* webpackChunkName: "addressEdit" */ '@/views/pages/address/AddressEdit.vue'),
      },
    ],
  },
  {
    path: '/suppliers',
    meta: {
      title: 'suppliers',
      requiresAuth: true,
      roles: ['ROLE_ADMIN'],
    },
    component: () =>
      import(/* webpackChunkName: "emptyRouterView" */ '@/views/pages/common/EmptyRouterView.vue'),
    children: [
      {
        path: '/suppliers',
        name: 'suppliers',
        meta: {
          title: 'Přehled dodavatelů',
          layout: Main,
          requiresAuth: true,
          roles: ['ROLE_ADMIN'],
        },
        component: () =>
          import(/* webpackChunkName: "suppliers" */ '@/views/pages/supplier/Suppliers.vue'),
      },
      {
        path: ':supplierId/detail',
        name: 'suppliers.detail',
        meta: {
          parent: 'suppliers',
          title: 'Detail dodavatele',
          layout: Main,
          requiresAuth: true,
          roles: ['ROLE_ADMIN'],
        },
        component: () =>
          import(
            /* webpackChunkName: "supplierDetail" */ '@/views/pages/supplier/SupplierDetail.vue'
          ),
      },
      {
        path: ':supplierId/edit',
        name: 'suppliers.edit',
        meta: {
          parent: 'suppliers.detail',
          title: 'Editace dodavatele',
          layout: Main,
          requiresAuth: true,
          roles: ['ROLE_ADMIN'],
        },
        component: () =>
          import(/* webpackChunkName: "supplierEdit" */ '@/views/pages/supplier/SupplierEdit.vue'),
      },
      {
        path: ':supplierId/product/:type/:productId/detail',
        name: 'suppliers.detail.product',
        meta: {
          parent: 'suppliers.detail',
          title: 'Detail produktu',
          layout: Main,
          requiresAuth: true,
          roles: ['ROLE_ADMIN'],
        },
        component: () =>
          import(
            /* webpackChunkName: "supplierProductDetail" */ '@/views/pages/supplier/SupplierProductDetail.vue'
          ),
      },
      {
        path: ':supplierId/product/:type/add',
        name: 'suppliers.detail.product.add',
        meta: {
          parent: 'suppliers.detail',
          title: 'Nový produkt',
          layout: Main,
          requiresAuth: true,
          roles: ['ROLE_ADMIN'],
        },
        component: () =>
          import(
            /* webpackChunkName: "supplierProductAdd" */ '@/views/pages/supplier/SupplierProductAdd.vue'
          ),
      },
      {
        path: ':supplierId/product/:type/:productId/edit',
        name: 'suppliers.detail.product.edit',
        meta: {
          parent: 'suppliers.detail.product',
          title: 'Editace produktu',
          layout: Main,
          requiresAuth: true,
          roles: ['ROLE_ADMIN'],
        },
        component: () =>
          import(
            /* webpackChunkName: "supplierProductEdit" */ '@/views/pages/supplier/SupplierProductEdit.vue'
          ),
      },
    ],
  },
  {
    path: '/gifts',
    meta: {
      title: 'gifts',
      requiresAuth: true,
      roles: ['ROLE_ADMIN'],
    },
    component: () =>
      import(/* webpackChunkName: "emptyRouterView" */ '@/views/pages/common/EmptyRouterView.vue'),
    children: [
      {
        path: '/gifts',
        name: 'gifts',
        meta: {
          title: 'Přehled dárků',
          layout: Main,
          requiresAuth: true,
          roles: ['ROLE_ADMIN'],
        },
        component: () => import(/* webpackChunkName: "gifts" */ '@/views/pages/gift/Gifts.vue'),
      },
      {
        path: ':giftId/detail',
        name: 'gifts.detail',
        meta: {
          parent: 'gifts',
          title: 'Detail dárku',
          layout: Main,
          requiresAuth: true,
          roles: ['ROLE_ADMIN'],
        },
        component: () =>
          import(/* webpackChunkName: "giftDetail" */ '@/views/pages/gift/GiftDetail.vue'),
      },
      {
        path: 'add',
        name: 'gifts.add',
        meta: {
          parent: 'gifts',
          title: 'Nový dárek',
          layout: Main,
          requiresAuth: true,
          roles: ['ROLE_ADMIN'],
        },
        component: () => import(/* webpackChunkName: "giftAdd" */ '@/views/pages/gift/GiftAdd.vue'),
      },
      {
        path: ':giftId/edit',
        name: 'gifts.edit',
        meta: {
          parent: 'gifts.detail',
          title: 'Editace dárku',
          layout: Main,
          requiresAuth: true,
          roles: ['ROLE_ADMIN'],
        },
        component: () =>
          import(/* webpackChunkName: "giftEdit" */ '@/views/pages/gift/GiftEdit.vue'),
      },
    ],
  },
  {
    path: '/promotions',
    meta: {
      title: 'promotions',
      requiresAuth: true,
      roles: ['ROLE_ADMIN'],
    },
    component: () =>
      import(/* webpackChunkName: "emptyRouterView" */ '@/views/pages/common/EmptyRouterView.vue'),
    children: [
      {
        path: '/promotions',
        name: 'promotions',
        meta: {
          title: 'Přehled propagací',
          layout: Main,
          requiresAuth: true,
          roles: ['ROLE_ADMIN'],
        },
        component: () =>
          import(/* webpackChunkName: "promotions" */ '@/views/pages/promotion/Promotions.vue'),
      },
      {
        path: ':promotionId/detail',
        name: 'promotions.detail',
        meta: {
          parent: 'promotions',
          title: 'Detail propagace',
          layout: Main,
          requiresAuth: true,
          roles: ['ROLE_ADMIN'],
        },
        component: () =>
          import(
            /* webpackChunkName: "promotionDetail" */ '@/views/pages/promotion/PromotionDetail.vue'
          ),
      },
      {
        path: 'add',
        name: 'promotions.add',
        meta: {
          parent: 'promotions',
          title: 'Nová propagace',
          layout: Main,
          requiresAuth: true,
          roles: ['ROLE_ADMIN'],
        },
        component: () =>
          import(/* webpackChunkName: "promotionAdd" */ '@/views/pages/promotion/PromotionAdd.vue'),
      },
      {
        path: ':promotionId/edit',
        name: 'promotions.edit',
        meta: {
          parent: 'promotions.detail',
          title: 'Editace propagace',
          layout: Main,
          requiresAuth: true,
          roles: ['ROLE_ADMIN'],
        },
        component: () =>
          import(
            /* webpackChunkName: "promotionEdit" */ '@/views/pages/promotion/PromotionEdit.vue'
          ),
      },
    ],
  },
  {
    path: '/messages',
    meta: {
      title: 'messages',
      requiresAuth: true,
      roles: ['ROLE_ADMIN'],
    },
    component: () =>
      import(/* webpackChunkName: "emptyRouterView" */ '@/views/pages/common/EmptyRouterView.vue'),
    children: [
      {
        path: '/messages',
        name: 'messages',
        meta: {
          title: 'Přehled zpráv a upozornění',
          layout: Main,
          requiresAuth: true,
          roles: ['ROLE_ADMIN'],
        },
        component: () =>
          import(/* webpackChunkName: "messages" */ '@/views/pages/message/Messages.vue'),
      },
      {
        path: ':id/detail',
        name: 'messages.detail',
        meta: {
          parent: 'messages',
          title: 'Detail zprávy',
          layout: Main,
          requiresAuth: true,
          roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
        },
        component: () =>
          import(/* webpackChunkName: "messageDetail" */ '@/views/pages/message/MessageDetail.vue'),
      },
      {
        path: ':id/edit',
        name: 'messages.edit',
        meta: {
          parent: 'messages.detail',
          title: 'Editace zprávy',
          layout: Main,
          requiresAuth: true,
          roles: ['ROLE_ADMIN'],
        },
        component: () =>
          import(/* webpackChunkName: "messageEdit" */ '@/views/pages/message/MessageEdit.vue'),
      },
      {
        path: 'add',
        name: 'messages.add',
        meta: {
          parent: 'messages',
          title: 'Nová zpráva',
          layout: Main,
          requiresAuth: true,
          roles: ['ROLE_ADMIN'],
        },
        component: () =>
          import(/* webpackChunkName: "messageAdd" */ '@/views/pages/message/MessageAdd.vue'),
      },
    ],
  },
  {
    path: '/personalized-offer',
    meta: {
      title: 'personalized-offer',
      requiresAuth: true,
      roles: ['ROLE_ADMIN'],
    },
    component: () =>
      import(/* webpackChunkName: "emptyRouterView" */ '@/views/pages/common/EmptyRouterView.vue'),
    children: [
      {
        path: '/personalized-offer',
        name: 'personalized-offer',
        meta: {
          title: 'Přehled nabídek',
          layout: Main,
          requiresAuth: true,
          roles: ['ROLE_ADMIN'],
        },
        component: () => import(/* webpackChunkName: "offers" */ '@/views/pages/offer/Offers.vue'),
      },
      {
        path: ':offerId/detail',
        name: 'personalized-offer.detail',
        meta: {
          parent: 'personalized-offer',
          title: 'Detail nabídky',
          layout: Main,
          requiresAuth: true,
          roles: ['ROLE_ADMIN'],
        },
        component: () =>
          import(/* webpackChunkName: "offerDetail" */ '@/views/pages/offer/OfferDetail.vue'),
      },
      {
        path: 'add',
        name: 'personalized-offer.add',
        meta: {
          parent: 'personalized-offer',
          title: 'Nová nabídka',
          layout: Main,
          requiresAuth: true,
          roles: ['ROLE_ADMIN'],
        },
        component: () =>
          import(/* webpackChunkName: "offerAdd" */ '@/views/pages/offer/OfferAdd.vue'),
      },
      {
        path: ':offerId/edit',
        name: 'personalized-offer.edit',
        meta: {
          parent: 'personalized-offer.detail',
          title: 'Editace nabídky',
          layout: Main,
          requiresAuth: true,
          roles: ['ROLE_ADMIN'],
        },
        component: () =>
          import(/* webpackChunkName: "offerEdit" */ '@/views/pages/offer/OfferEdit.vue'),
      },
    ],
  },
]

// eslint-disable-next-line
const scrollBehavior = (to, from, savedPosition) => {
  return {
    x: 0,
    y: 0,
  }
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior,
  routes,
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    const localStore = JSON.parse(localStorage.getItem('store'))
    if (!localStore || !localStore.accessToken) {
      next({
        name: 'login',
      })
      return
    }
    if (to.matched.some((record) => record.meta.roles)) {
      const { roles } = to.meta
      const userRoles = localStore.user.authorities
      const hasAccess = roles.reduce((found, item) => found || userRoles.includes(item), false)
      if (hasAccess) {
        next()
      } else {
        next({
          name: 'home',
        })
      }
      return
    }
    next()
  }
  next()
})

export default router
